import {Component, inject, Input, OnInit} from '@angular/core';
import {IonItem, IonList, PopoverController} from "@ionic/angular/standalone";
import {RouterLink} from "@angular/router";

@Component({
    selector: 'app-sub-menu',
    templateUrl: './sub-menu.component.html',
    styleUrls: ['./sub-menu.component.scss'],
    imports: [
        IonItem,
        IonList,
        RouterLink
    ]
})
export class SubMenuComponent  implements OnInit {

  @Input() subNavigation: any = [];
  @Input() dir: string = 'en';
  popoverController: PopoverController = inject(PopoverController);
  constructor() { }

  ngOnInit() {}

}
